export const Notifications_LastRefreshDate = 'Notifications_LastRefreshDate';
export const Notifications_RefreshTimeInMinutes = 5;